import { cmsCLient } from '@/services/axiosConfig'
import { Preorder } from './types'

export type GetPreorderRes = Preorder

export type GetPreorder = (id: string | undefined) => Promise<GetPreorderRes>

export const getPreOrder: GetPreorder = async (id) => {
  try {
    if (id !== undefined) {
      const response = await cmsCLient.get('/preorder?id=' + id.toString())
      return response.data.data
    }
  } catch (e: any) {
    return e.message
  }
}
